// @ts-nocheck
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index.store';
import VueMeta from 'vue-meta';
import VueI18n from 'vue-i18n';
import VeeValidate from 'vee-validate';
import VeeValidateMessagesNO from './vee-validate/locale/nb_NO';
import {parsePhoneNumberFromString} from 'libphonenumber-js/mobile';
import i18n from '@modules/i18n/i18n';
import VueGtm from 'vue-gtm';
import {loadRaven} from '@modules/husleie-framework/src/loadRaven';
import '@modules/husleie-framework/src/fixNumberInputScrollChange';
import 'bootstrap/scss/bootstrap.scss';
import '@modules/husleie-framework/icons/budicon/Combined/style.css';
import postHogPlugin from '@modules/husleie-framework/src/posthog.ts';

if (process.env.VUE_APP_ANALYTICS_ACTIVATED && process.env.VUE_APP_ANALYTICS_GTM_ID) {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_ANALYTICS_GTM_ID,
    enabled: true,
    debug: false,
  });
}

if (process.env.VUE_APP_POSTHOG_ACTIVATED === 'true' && process.env.VUE_APP_POSTHOG_API_KEY) {
  Vue.use(postHogPlugin, { router });
}

Vue.use(VueI18n);
Vue.use(VueMeta);

// Phone validation
Vue.use(VeeValidate, { errorBagName: '_hl_errors', fieldsBagName: '_hl_fields' });
VeeValidate.Validator.localize('nb_NO', VeeValidateMessagesNO);
VeeValidate.Validator.extend('valid-cell-phone', {
    getMessage(field) {
      return 'Feltet ' + field + ' er ikke ett gyldig mobilnummer';
    },
    validate:(value) => {
      try {
        // @ts-ignore
        let phone_prefix = window.tenant_phone_prefix;
        if (!phone_prefix) {
          phone_prefix = '+47';
        }
        let phone_number = parsePhoneNumberFromString(phone_prefix + value);
        // @ts-ignore
        return phone_number.isValid() && phone_number.getType() === 'MOBILE';
      }
      catch(error) {
        return false;
      }
    }
}, {
    immediate: true,
});

Vue.config.productionTip = false;

loadRaven(Vue);

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
